import { Plus, Minus, PanelLeft, Settings2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MobileFAB } from './ui/MobileFAB';
// BRAND_NAVY moved into MobileFAB (the only former consumer here).

interface MobileCanvasControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFitView: () => void;
  onOpenTools: () => void;
  onOpenProperties: () => void;
}

export function MobileCanvasControls({
  zoom, onZoomIn, onZoomOut, onFitView, onOpenTools, onOpenProperties,
}: MobileCanvasControlsProps) {
  const pct = Math.round(zoom * 100);

  return (
    <div
      className="absolute left-0 right-0 flex items-end justify-between z-30 pointer-events-none"
      style={{
        bottom: 'max(16px, env(safe-area-inset-bottom, 16px))',
        // Landscape on iPhone X+ puts the notch on left/right; respect
        // both safe-areas so FABs don't slide under the rounded edges.
        paddingLeft: 'max(16px, env(safe-area-inset-left, 16px))',
        paddingRight: 'max(16px, env(safe-area-inset-right, 16px))',
      }}
    >
      {/* Left: open tool sheet */}
      <MobileFAB icon={PanelLeft} onClick={onOpenTools} ariaLabel="Open tools" />

      {/* Center: zoom controls */}
      <div className="flex items-center gap-1 bg-background/90 backdrop-blur-sm rounded-full shadow-lg border border-border px-1 py-1 pointer-events-auto">
        <Button variant="ghost" size="icon" className="h-10 w-10 rounded-full" onClick={onZoomOut} aria-label="Zoom out">
          <Minus className="w-4 h-4" />
        </Button>
        <button onClick={onFitView} className="text-xs font-medium px-2 min-w-[44px] h-10 rounded-full active:bg-muted transition-colors" aria-label="Fit view">
          {pct}%
        </button>
        <Button variant="ghost" size="icon" className="h-10 w-10 rounded-full" onClick={onZoomIn} aria-label="Zoom in">
          <Plus className="w-4 h-4" />
        </Button>
      </div>

      {/* Right: open properties sheet */}
      <MobileFAB icon={Settings2} onClick={onOpenProperties} ariaLabel="Open properties" />
    </div>
  );
}
